import { matchPath } from "react-router-dom";

import PATHS from "../consts/urlPaths";
import {
  loadInsightsPage,
  loadPersonDetailPage,
  loadPositionDetailPage,
  loadSearchPage,
  loadTeamDetailPage,
  loadTeamListPage,
  loadWorkforcePage,
} from "./lazyRouteLoaders";

// The pages people open directly from a link or a reload. This runs before
// sign-in, so it cannot use the feature-flagged getRoutes table; it re-states
// a few of the path/loader pairs in PREFETCH_LOADER_BY_PATH
// (getRoutes/index.js). preloadRouteChunk.test.js checks the two agree.
// Longest paths first so `/teams/:id/...` is not taken for `/teams`.
export const ROUTE_CHUNKS = [
  [PATHS.TEAM_DETAILS, loadTeamDetailPage],
  [PATHS.TEAM_DETAILS_BASE_PATH, loadTeamDetailPage],
  [PATHS.PERSON_DETAILS, loadPersonDetailPage],
  [PATHS.PERSON_DETAILS_BASE_PATH, loadPersonDetailPage],
  [PATHS.POSITION_DETAILS, loadPositionDetailPage],
  [PATHS.POSITION_DETAILS_BASE_PATH, loadPositionDetailPage],
  [PATHS.INSIGHTS, loadInsightsPage],
  [PATHS.WORKFORCE, loadWorkforcePage],
  [PATHS.WORKFORCE_ROOT, loadWorkforcePage],
  [PATHS.SEARCH, loadSearchPage],
  [PATHS.TEAMS, loadTeamListPage],
];

export const findRouteChunkLoader = (pathname) => {
  for (const [path, loader] of ROUTE_CHUNKS) {
    if (matchPath(pathname, { path, exact: true })) {
      return loader;
    }
  }
  return undefined;
};

/**
 * Start downloading the page chunk for the URL being opened. Without this the
 * chunk only starts after sign-in and the config queries finish, which puts a
 * download in front of the first page query.
 */
export const preloadRouteChunk = (pathname) => {
  const loader = findRouteChunkLoader(pathname);
  if (loader) {
    void loader().catch(() => undefined);
  }
};
